import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-root-layout',
  templateUrl: './root-layout.component.html',
  styleUrls: ['./root-layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RootLayoutComponent {}
